import { Box, Tooltip, Typography } from '@mui/material';
import { WD } from '../../../warningDashboard/warningTheme';
import { CARD_BG, FIGURE, LEVEL_TONE } from '../utils/constants';
import { formatWeekday } from '../utils/dates';
import { fmtHours, levelForPct } from '../utils/hours';

/** A person's week as bars against the dashed capacity line: past days logged, today and later what is left. */
export default function WeekChart({ week, today, capacityPerDay }) {
  const peak = Math.max(capacityPerDay * 1.5, ...week.map((day) => day.hours), 1);

  return (
    <Box sx={{ mt: 3, bgcolor: CARD_BG, border: `1px solid ${WD.border}`, borderRadius: 3, p: 2 }}>
      <Box display="flex" alignItems="baseline" justifyContent="space-between" gap={2}>
        <Typography component="h3" sx={{ fontSize: 14, fontWeight: 700, color: WD.ink }}>This week</Typography>
        <Typography sx={{ fontSize: 11.5, color: WD.inkFaint }}>- - {capacityPerDay}h capacity</Typography>
      </Box>

      <Box sx={{ position: 'relative', mt: 1.5, height: 120 }}>
        <Box aria-hidden sx={{ position: 'absolute', left: 0, right: 0, bottom: `${(capacityPerDay / peak) * 100}%`, borderTop: `1px dashed ${WD.inkFaint}` }} />
        <Box display="flex" alignItems="flex-end" justifyContent="space-between" gap={1} sx={{ position: 'absolute', inset: 0 }}>
          {week.map((day) => {
            const level = day.capacity ? levelForPct((day.hours / day.capacity) * 100) : null;
            return (
              <Box key={day.day} display="flex" flexDirection="column" justifyContent="flex-end" sx={{ flex: 1, height: '100%' }}>
                <Tooltip title={`${fmtHours(day.hours)}${day.capacity ? '' : ' · day off'}`}>
                  <Box
                    sx={{
                      width: '100%',
                      height: `${Math.max(day.hours ? 4 : 2, (day.hours / peak) * 100)}%`,
                      borderRadius: '6px 6px 0 0',
                      bgcolor: level ? LEVEL_TONE[level].accent : '#EFEDE6',
                      opacity: day.day < today ? 0.6 : 1,
                      outline: day.day === today ? `2px solid ${WD.green}` : 'none',
                      outlineOffset: 1,
                    }}
                  />
                </Tooltip>
              </Box>
            );
          })}
        </Box>
      </Box>

      <Box display="flex" justifyContent="space-between" gap={1} sx={{ mt: 1 }}>
        {week.map((day) => (
          <Box key={day.day} sx={{ flex: 1, textAlign: 'center' }}>
            <Typography sx={{ fontSize: 11, fontWeight: day.day === today ? 700 : 500, color: day.day === today ? WD.green : WD.inkFaint }}>
              {formatWeekday(day.day)}
              {day.day === today ? ' · today' : ''}
            </Typography>
            <Typography sx={{ fontSize: 12, fontWeight: 700, color: WD.ink, ...FIGURE }}>{day.capacity ? fmtHours(day.hours) : 'off'}</Typography>
          </Box>
        ))}
      </Box>
      <Typography sx={{ mt: 1, fontSize: 11, color: WD.inkFaint }}>Past days show time logged; today and later show remaining planned hours.</Typography>
    </Box>
  );
}
